// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__kjsTs","author":"Table_author__cCmGT","authorImage":"Table_authorImage__1og_o","unreadRow":"Table_unreadRow__1p-Bj"};